import { Injectable, Injector } from "@angular/core";
import { createEffect, ofType, Actions } from "@ngrx/effects";
import { of } from "rxjs/internal/observable/of";
import { catchError, switchMap, map } from "rxjs/operators";
import { Store } from "@ngrx/store";
import * as UserActions from "../actions/user.action";

@Injectable()
export class UserEffects {
    private store = this.injector.get(Store);
    private _actions$ = this.injector.get(Actions);

    constructor(private injector: Injector) { }

    // descomentar cuando se inicie desarrollo 
    // loginUser$ = createEffect(() =>
    //     this._actions$.pipe(
    //         ofType(UserActions.loginAction),
    //         switchMap((action) => {
    //             return service;
    //         }),
    //         catchError((error) =>
    //             of(UserActions.loginErrorAction(error.error.message))
    //         )
    //     )
    // );
}
